export const BREAKPOINTS = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
} as const

export const media = {
  mobile: `(max-width: ${BREAKPOINTS.tablet - 1}px)`,
  tablet: `(min-width: ${BREAKPOINTS.tablet}px) and (max-width: ${BREAKPOINTS.desktop - 1}px)`,
  desktop: `(min-width: ${BREAKPOINTS.desktop}px)`,
  belowTablet: `(max-width: ${BREAKPOINTS.tablet - 1}px)`,
  belowDesktop: `(max-width: ${BREAKPOINTS.desktop - 1}px)`,
} as const

export const isMobileViewport = () =>
  typeof window !== 'undefined' && window.matchMedia(media.belowTablet).matches
